<template>
  <div>
    <PageHead title="已收通知"></PageHead>
    <div class="oa-layout-content">
      <div class="search-flex">
        <div class="query-top-select">
          <div class="query-cont">
            <div class="query-view mr20">
              <div class="query-view-lable">标题：</div>
              <a-input
                allowClear
                class="w200"
                placeholder="请输入标题"
                v-model="queryForm.titleName"
              />
            </div>
            <div class="query-view mr20">
              <div class="query-view-lable">确认状态：</div>
              <a-select
                allowClear
                placeholder="不限"
                class="w200"
                v-model="queryForm.affirmState"
              >
                <a-select-option :value="0">未确认</a-select-option>
                <a-select-option :value="1">已确认</a-select-option>
              </a-select>
            </div>
            <div class="query-view">
              <div class="query-view-lable">回复状态：</div>
              <a-select
                allowClear
                placeholder="不限"
                class="w200"
                v-model="queryForm.replyState"
              >
                <a-select-option :value="0">未回复</a-select-option>
                <a-select-option :value="1">已回复</a-select-option>
                <a-select-option :value="3">无需回复</a-select-option>
              </a-select>
            </div>
          </div>
        </div>
        <div class="search-flex-itemm">
          <a-button type="primary" @click="subMit" :loading="loading">
            查询</a-button
          >
          <a-button :style="{ marginLeft: '8px' }" @click="cancel()">
            取消
          </a-button>
        </div>
      </div>
      <div class="mb20 search-btns mt20">
        <!-- <a-button type="primary" @click="goDetial()" icon="plus">
          发送通知</a-button
        > -->
        <span class="statistics"> 检索统计： {{ total }} 条 </span>
      </div>

      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="(record) => record.id"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ index + 1 + (page - 1) * 10 }}
        </span>
        <div slot="affirmState" class="statusDiv" slot-scope="text">
          <span v-if="text == 0"> 未确认 </span>
          <span v-if="text == 1"> 已确认 </span>
        </div>
        <div slot="replyState" class="statusDiv" slot-scope="text">
          <span v-if="text == 0"> 未回复 </span>
          <span v-if="text == 1"> 已回复 </span>
          <span v-if="text == 3"> 无需回复 </span>
        </div>
        <div slot="action" slot-scope="text, record">
          <a-button type="link" class="btn-link" @click="goDetial(record)">
            查看
          </a-button>
          <template v-if="record.replyState == 1">
            <a-divider type="vertical" />
            <a-button type="link" class="btn-link" @click="goReply(record)">
              查看回复
            </a-button>
          </template>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="page"
          :default-current="page"
          :total="total"
          :pageSize="size"
          @change="pageChange"
        />
      </div>
    </div>
    <appfloor></appfloor>
  </div>
</template>
<script>
const columns = [
  {
    title: "序号",
    dataIndex: "index",
    key: "index",
    scopedSlots: { customRender: "index" },
    width: 80,
  },

  {
    title: "标题",
    dataIndex: "titleName",
    key: "titleName",
    ellipsis: true,
  },

  {
    title: "发送部门",
    dataIndex: "organizationName",
    key: "organizationName",
    ellipsis: true,
  },
  {
    title: "发送人",
    dataIndex: "iniatorName",
    key: "iniatorName",
    ellipsis: true,
  },
  {
    title: "发送时间",
    dataIndex: "createTime",
    key: "createTime",
    ellipsis: true,
  },
  {
    title: "确认状态",
    dataIndex: "affirmState",
    key: "affirmState",
    scopedSlots: { customRender: "affirmState" },
    ellipsis: true,
  },
  {
    title: "回复状态",
    dataIndex: "replyState",
    key: "replyState",
    scopedSlots: { customRender: "replyState" },
    ellipsis: true,
  },

  {
    key: "operation",
    scopedSlots: { customRender: "action" },
    title: "操作",
    align: "left",
    width: 180,
  },
];

import { partyNoticeUserList } from "./api/api";
export default {
  data() {
    return {
      queryForm: {},
      data: [],
      columns,
      total: 0,
      page: 1,
      size: 10,
      loading: false,
    };
  },

  created() {
    this.load();
  },
  methods: {
    // 拉取列表
    load() {
      this.loading = true;
      let params = this.queryForm;
      params.page = this.page;
      params.size = this.size;
      params.userId = this.$store.state.app.userInfo.id;
      partyNoticeUserList(params).then((res) => {
        this.loading = false;
        if (res.data.code == 0) {
          this.data = res.data.data;
          this.total = res.data.count;
        }
      });
    },
    // 查看回复
    goReply(item) {
      const { href } = this.$router.resolve({
        path: "/AccountingComputerizationNoticeReply",
        query: {
          id: item.id,
          isEdit: "1",
          isLook: "1",
          partyNoticeId: item.partyNoticeId,
        },
      });
      window.open(href, "_self");
    },
    goDetial(item) {
      if (item.replyState == 1) {
        //已回复 回复详情页
        // const { href } = this.$router.resolve({
        //   path: "/AccountingComputerizationNoticeReply",
        //   query: {
        //     id: item.id,
        //     isEdit: "1",
        //     partyNoticeId: item.partyNoticeId,
        //   },
        // });
        // window.open(href, "_self");
        const { href } = this.$router.resolve({
          path: "/AccountingComputerizationNoticeDetial",
          query: {
            id: item.partyNoticeId,
            isEdit: "1",
          },
        });
        window.open(href, "_self");
      } else {
        if (item.isCopypresent == 1) {
          //抄送
          const { href } = this.$router.resolve({
            path: "/AccountingComputerizationNoticeDetial",
            query: {
              id: item.partyNoticeId,
              isEdit: "1",
            },
          });
          window.open(href, "_self");
        } else {
          //主送
          if (item.affirmState == 1) {
            //已确认
            const { href } = this.$router.resolve({
              path: "/AccountingComputerizationNoticeDetial",
              query: {
                id: item.partyNoticeId,
                isEdit: "1",
                isType: "1",
                UserNoticeID: item.id,
              },
            });
            window.open(href, "_self");
          } else {
            // 未确认
            const { href } = this.$router.resolve({
              path: "/AccountingComputerizationNoticeDetial",
              query: {
                id: item.partyNoticeId,
                isEdit: "1",
                isType: "2",
                UserNoticeID: item.id,
              },
            });
            window.open(href, "_self");
          }
        }
      }
    },
    pageChange(pageber) {
      this.page = pageber;
      this.load();
    },
    cancel() {
      //取消
      this.queryForm = {};
    },
    subMit() {
      this.page = 1;
      this.load();
    },
  },
};
</script>
<style lang="scss" scoped>
.search-flex {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  .query-top-select {
    width: calc(100% - 180px);
    .query-cont {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      // flex-wrap: wrap;
      .query-view {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        .query-view-lable {
          width: 75px;
          height: 22px;
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          line-height: 22px;
          text-align: right;
          margin-right: 5px;
        }
      }
    }
  }
  .search-flex-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}
.search-btns {
  position: relative;
  .statistics {
    position: absolute;
    right: 50px;
    font-size: 14px;
  }
}

.statusDiv {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/views/AccountingComputerizationNotice/received.vue